import { LicenseTrialSubFormController } from '../controller/LicenseTrialSubFormController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { LicenseSubFormComponent } from '../../types/LicenseSubFormComponent';
import { Observable } from 'rxjs';
import { FormGroupValue } from '../../../ui/gzForm/formGroup/types/form-group-value';
import { CompanyData } from '../../../company/types/company-data';

export class LicenseTrialSubFormWebComponent extends BaseWebComponentElement implements LicenseSubFormComponent {
  public controller!: LicenseTrialSubFormController;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: LicenseTrialSubFormController,
    });
  }

  public get valid$(): Observable<boolean> {
    return this.controller.view.formGroup.valid$;
  }

  public get value(): FormGroupValue {
    return this.controller.view.formGroup.value;
  }

  public setViewData(): void {
    // noop, this subform doesn't use the context
  }

  public setCompanyData(company: CompanyData): void {
    this.controller.view.setCompanyData(company);
  }
}
